import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectCostIT } from "../Model/ProposalProjectCostIT";

export async function deleteProposalProjectCostIT(id) {
    let response = await getAPIResponse("/v1/proposal-project-cost-it/"+id, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let proposalProjectCostIT = ProposalProjectCostIT.createFromResponseData(response);
    return proposalProjectCostIT;
}